import merge from 'lodash.merge';

/* eslint-disable object-curly-newline */
export function getScriptSettings(domain = window.location.hostname) {
  window.bt = window.bt || {};

  // environment-independent settings
  const defaultSettings = {
    isMember: window.sessionStorage.getItem('isMember') === 'true',
    vipClub: {
      funnels: {
        '*': false, // disable VIP all funnels, unless explicitly listed here.
      },
      productSku: '5001',
      membershipPrice: 12.44,
      membershipInterval: 'month',
      membershipDiscount: '50%',
    },
    conversionPixelFindOfferId: true, // Should the conversion pixel search the page for an offer id?
  };

  let {
    settings = {},
    trackers: {
      // eslint-disable-next-line prefer-const
      init: initConfig = {
        supressOptimizer: true, // default is to suppress optimize hiding snippet, unless otherwise specified
      },
    } = {},
  } = window.bt;

  let env;
  let envSettings = {};

  if (domain === 'www.biotrust.com' || domain === 'secure.biotrust.com') {
    env = 'production';
    envSettings = {
      gaTag: 'UA-118296754-1',
      ga4MeasurementId: 'G-D4LG4PVNQ9',
      gaServerSideTaggingDomain: 'sst.biotrust.com',
      optimize: {
        tag: '', // Optimize has been sunset. 'GTM-T4Z8VVW',
        suppress: true, // globally suppress optmize hiding snippet
      },
      gtmTag: 'GTM-KP43SJ7',
      adwords: {tag: 'AW-800350678', sequence: 'sN1qCL3c4YQBENbD0f0C', ledGenSequence: 'DhktCNCZp7MBENbD0f0C'},
      hasoffers: 'https://offers.biotrust.com/',
      hasOffersLoggingEnabled: true,
      cj: {
        coupon: '3JCGNWHPP1YQ',
        couponText: '20% off CJ order',
      },
      outbrain: {tag: '000c62a6b914284f7d1adbc81c98f8b892', testMode: false},
      bingTag: '5176029',
      tiktokTag: 'CIEAAMBC77U2H86MK7J0',
      statsUrl: 'https://stats.biotrust.com/',
      conversionpixelJS: 'https://dgcc54ypsl4m0.cloudfront.net/conversionpixel.js',
      conversionPixelFindOfferId: domain !== 'secure.biotrust.com',
      yopto: 'https://staticw2.yotpo.com/3K2SShe8FNCWby39ocJrHbbGHnkcyAby9i3fFZEn/widget.js',
      leadsApi: 'https://leadsapi.biotrust.com/api/',
      fbTag: '1639689789688341',
      sessionCookieName: 'bt-conv',
      debug: true,
      maropost: {
        scriptUrl: null,
        func: null,
      },
      splitTests: {attentive: {funnelIds: []} },
      carthook: {storefrontFunnelId: '18DshiOTS6gbIMoUBB6s'},
      catchjs: {enabled: true},
      taboolaAccountId: 1072326,
      trackersDataLayerName: 'trackersJsDataLayer',
      consentBar: {
        enabledRegions: ['CA'],
        disabledPages: ['flavor-selection', '/oto/'],
      },
      eBooks: ['9001', '9002'],
      getEmail: {
        ver: '1.5.1',
      },
      vipClub: {
        enabled: false,
      },
      hidePortalVariantIds:
      '',
      hidePortalVariantTitles:
      '',
      rockerBox: {
        tagId: 'YmlvdHJ1c3R8dmlld3xwdXJjaGFzZXxzaWdudXB8bG9naW4=',
      },
      amazon: {
        viewTagId: '_pix_id_2abab93f-10c2-e303-33e8-323aa0654dfe',
        conversionTagId: '_pix_id_06abb94a-398e-17b8-ca15-167e980d6c6b',
      },
      cagePointProjectId: '132696072',
      klaviyo: {
        publicApiKey: 'V3hpXm',
      },
      audacy: {
        projectId: 23661,
      },
    };
  } else if (
    domain === 'staging.biotrust.com'
    || domain === 'qa-secure.biotrust.com'
    || domain === 'staging-secure.biotrust.com'
    || domain === 'localhost') {
    env = 'staging';
    envSettings = {
      gaTag: 'UA-118296754-2',
      ga4MeasurementId: 'G-Q2VQ5H9P09',
      gaServerSideTaggingDomain: 'sst-staging.biotrust.com',
      gtmTag: 'GTM-MT4VTV3',
      adwords: {tag: 'AW-688669500', sequence: 'HbULCISErrYBELyGscgC', ledGenSequence: 'k4NlCILhuLYBELyGscgC'},
      optimize: {
        tag: '', // Optimize has been sunset. 'GTM-PG4XWLF',
        suppress: true,
      },
      hasoffers: 'https://devoffers.biotrust.com/',
      hasOffersLoggingEnabled: true,
      cj: {
        coupon: '3JCGNWHPP1YQ',
        couponText: '20% off CJ order',
      },
      outbrain: {tag: '', testMode: true}, // We don't have a staging account
      bingTag: '27003950',
      tiktokTag: 'CIEAAMBC77U2H86MK7J0',
      statsUrl: 'https://staging-stats.biotrust.com/',
      conversionpixelJS: 'https://dvj73564ouxru.cloudfront.net/conversionpixel.js',
      conversionPixelFindOfferId: domain !== 'staging-secure.biotrust.com',
      yopto: 'https://staticw2.yotpo.com/LghR0v050oAsWuIYy5lpTUXgZpqn0bIVVeZi6vgQ/widget.js',
      leadsApi: 'https://staging-leadsapi.biotrust.com/api/',
      fbTag: '1957813487611672',
      sessionCookieName: 'bt-conv-staging',
      debug: true,
      maropost: {
        scriptUrl: null,
        func: null,
      },
      // eslint-disable-next-line camelcase, max-len
      splitTests: {
        maw: {splitTestVariations: {'': '1'} },
        attentive: {splitTestVariations: {'': '1'} },
        vip: {
          splitTestType: '',
          splitTestVariations: {},
          bundleParams: {},
        },
      },
      carthook: {storefrontFunnelId: 'JSCvOF94UZqxCssYVRIy'},
      catchjs: {enabled: false},
      taboolaAccountId: 1299006,
      trackersDataLayerName: 'trackersJsDataLayer',
      consentBar: {
        enabledRegions: ['CA'],
        disabledPages: ['flavor-selection', '/oto/'],
      },
      eBooks: ['9001', '9002'],
      getEmail: {
        ver: '1.5.1',
      },
      vipClub: {
        membershipVariantId: 31902284677186, // staging variant id
        membershipSubscriptionId: '245670',
      },
      hidePortalVariantIds:
      '',
      hidePortalVariantTitles:
      '',
      rockerBox: {
        tagId: 'YmlvdHJ1c3RkZXZ8dmlld3xwdXJjaGFzZXxzaWdudXB8bG9naW4=',
      },
      amazon: {
        viewTagId: '',
        conversionTagId: '',
      },
      cagePointProjectId: '', // We don't have a staging account
      klaviyo: {
        publicApiKey: 'QQREvH',
      },
      audacy: {
        projectId: 0, // We don't have a staging account
      },
    };
  }

  settings = merge({}, defaultSettings, envSettings, settings);

  window.bt.settings = settings;

  return {settings, env, initConfig};
}
